export const NAME = 'appointmentDates';